import { t } from "i18next"

export function getBasePage(): any {
    return {
        "page": {
            "body": {
                "container": {
                    "style": {
                        "background-color": "transparent"
                    }
                },
                "content": {
                    "computedStyle": {
                        "linkColor": "#323e49",
                        "messageBackgroundColor": "transparent",
                        "messageWidth": "1440px"
                    },
                    "style": {
                        "color": "#000000",
                        "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif"
                    }
                },
                "type": "mailup-bee-page-properties",
                "webFonts": [
                    {
                        "fontFamily": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                        "name": "Montserrat",
                        "url": "https://fonts.googleapis.com/css?family=Montserrat"
                    }
                ]
            },
            "description": "",
            "rows": [
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "50px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "49775695-9ea1-40fe-9974-4362f53b4fc0"
                                },
                                {
                                    "descriptor": [],
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-empty",
                                    "uuid": "80a03d7a-e60b-4ef3-978c-bee6971d8348"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "58dc6d83-265a-4e52-a0e9-44b950092cb4"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#efe6d7",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": true
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "1440px"
                        }
                    },
                    "locked": false,
                    "type": "row-1-columns-12",
                    "uuid": "571af74a-9dfa-43b3-8e8b-80a7261f27e5"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 4,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnDesktop": false,
                                            "hideContentOnMobile": false,
                                            "iconHeight": "32px",
                                            "iconSpacing": {
                                                "padding-bottom": "5px",
                                                "padding-left": "5px",
                                                "padding-right": "5px",
                                                "padding-top": "5px"
                                            },
                                            "itemSpacing": "0px"
                                        },
                                        "iconsList": {
                                            "icons": [
                                                {
                                                    "alt": "Search",
                                                    "height": "52px",
                                                    "href": "https://www.example.com",
                                                    "image": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_MENUICONS_SEARCH.png",
                                                    "target": "_self",
                                                    "text": "",
                                                    "textPosition": "right",
                                                    "title": "",
                                                    "width": "52px"
                                                }
                                            ]
                                        },
                                        "style": {
                                            "color": "#000000",
                                            "font-family": "inherit",
                                            "font-size": "14px",
                                            "padding-bottom": "0px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "0px",
                                            "text-align": "left"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-icons",
                                    "uuid": "1db6daa9-c064-477f-8b30-84c0b9b12fc8"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "3cae4081-e918-4f80-888e-eb4c279c1185"
                        },
                        {
                            "grid-columns": 4,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center autowidth",
                                            "hideContentOnMobile": false,
                                            "width": "205px"
                                        },
                                        "image": {
                                            "alt": "Your Logo",
                                            "height": "139px",
                                            "href": "https://www.example.com",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_YOURLOGO.png",
                                            "width": "205px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "b74dc7d5-d8c1-4343-985a-c8149eae52c4"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "d55b712d-1f70-4e82-b867-bbc576aaf469"
                        },
                        {
                            "grid-columns": 4,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnDesktop": false,
                                            "hideContentOnMobile": false,
                                            "iconHeight": "32px",
                                            "iconSpacing": {
                                                "padding-bottom": "5px",
                                                "padding-left": "5px",
                                                "padding-right": "5px",
                                                "padding-top": "5px"
                                            },
                                            "itemSpacing": "0px",
                                            "itemsSpacing": "10px"
                                        },
                                        "iconsList": {
                                            "icons": [
                                                {
                                                    "alt": "Account",
                                                    "height": "52px",
                                                    "href": "https://www.example.com",
                                                    "image": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_MENUICONS_ACCOUNT.png",
                                                    "target": "_self",
                                                    "text": "",
                                                    "textPosition": "right",
                                                    "title": "",
                                                    "width": "43px"
                                                },
                                                {
                                                    "alt": "Favourites",
                                                    "height": "52px",
                                                    "href": "https://www.example.com",
                                                    "image": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_MENUICONS_FAV.png",
                                                    "target": "_self",
                                                    "text": "",
                                                    "textPosition": "right",
                                                    "title": "",
                                                    "width": "54px"
                                                },
                                                {
                                                    "alt": "Checkout",
                                                    "height": "52px",
                                                    "href": "https://www.example.com",
                                                    "image": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_MENUICONS_BAG.png",
                                                    "target": "_self",
                                                    "text": "",
                                                    "textPosition": "right",
                                                    "title": "",
                                                    "width": "59px"
                                                }
                                            ]
                                        },
                                        "style": {
                                            "color": "#323e49",
                                            "font-family": "inherit",
                                            "font-size": "14px",
                                            "padding-bottom": "0px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "0px",
                                            "text-align": "right"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-icons",
                                    "uuid": "9e9c2649-a970-4506-a8d0-c851effd6b17"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "a4393523-ad32-43de-adcb-c2b608c3cded"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#efe6d7",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "three-columns-empty",
                    "uuid": "bb70250f-b404-4d26-8121-6434f9d77011"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "20px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "175679f9-0ba4-485b-b9c0-77de3d46a183"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hamburger": {
                                                "backgroundColor": "#000000",
                                                "foregroundColor": "#ffffff",
                                                "iconSize": "36px",
                                                "iconType": "normal",
                                                "mobile": false
                                            },
                                            "hideContentOnDesktop": false,
                                            "hideContentOnMobile": false,
                                            "layout": "horizontal",
                                            "linkColor": "#323e49",
                                            "menuItemsSpacing": {
                                                "padding-bottom": "5px",
                                                "padding-left": "15px",
                                                "padding-right": "15px",
                                                "padding-top": "5px"
                                            }
                                        },
                                        "menuItemsList": {
                                            "items": [
                                                {
                                                    "link": {
                                                        "href": "https://www.example.com",
                                                        "target": "_self",
                                                        "title": ""
                                                    },
                                                    "text": "NEW COLLECTION"
                                                },
                                                {
                                                    "link": {
                                                        "href": "https://www.example.com",
                                                        "target": "_self",
                                                        "title": ""
                                                    },
                                                    "text": "FURNITURE"
                                                },
                                                {
                                                    "link": {
                                                        "href": "https://www.example.com",
                                                        "target": "_self",
                                                        "title": ""
                                                    },
                                                    "text": "DECOR"
                                                },
                                                {
                                                    "link": {
                                                        "href": "https://www.example.com",
                                                        "target": "_self",
                                                        "title": ""
                                                    },
                                                    "text": "ACCESSORIES"
                                                },
                                                {
                                                    "link": {
                                                        "href": "https://www.example.com",
                                                        "target": "_self",
                                                        "title": ""
                                                    },
                                                    "text": "BLOG"
                                                }
                                            ]
                                        },
                                        "style": {
                                            "color": "#323e49",
                                            "font-family": "inherit",
                                            "font-size": "14px",
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "text-align": "center"
                                        }
                                    },
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-menu",
                                    "uuid": "244f1fdd-8fb1-4a00-8440-9adc4dfb3ffd"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "20px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "a59e3469-20dc-4670-8c77-f80f783c36da"
                                },
                                {
                                    "descriptor": [],
                                    "locked": false,
                                    "type": "mailup-bee-newsletter-modules-empty",
                                    "uuid": "adcf132f-9b12-4069-b0b6-560a11aeda41"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "58dc6d83-265a-4e52-a0e9-44b950092cb4"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#efe6d7",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": true
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "1440px"
                        }
                    },
                    "locked": false,
                    "type": "row-1-columns-12",
                    "uuid": "631e19ce-282a-416d-ba82-49f04d2fa2fc"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "80px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "1fcef7fc-ece9-4b81-82fd-358adb6c7f4f"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><span style=\"font-size: 42px; line-height: 50px;\" data-mce-style=\"font-size: 42px; line-height: 50px;\"><strong><span style=\"color: #8e364b; line-height: 14px;\" data-mce-style=\"color: #8e364b; line-height: 14px;\">FALL</span> <span style=\"color: #5e405a; line-height: 14px;\" data-mce-style=\"color: #5e405a; line-height: 14px;\">IN LOVE</span></strong></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "1eca4c53-d8b7-41aa-9ebd-0a4fb19a2335"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><span style=\"font-size: 20px; line-height: 24px; color: #323e49;\" data-mce-style=\"font-size: 20px; line-height: 24px; color: #323e49;\">with this season&apos;s collection</span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "b8c75c6d-bfdb-4db5-8c06-45e602eeb77a"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "66301f2d-59e8-48df-a759-0d74447f6d6f"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit<br>sed diam nonummy nibh euismod tincidunt ut laoreet dolore<br>aliquam erat volutpat. Ut wisi enim ad minim veniam, <br>quis nostrud exerci tation ullamcorper suscipit</span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "5b65fee0-fc10-4a8b-8a49-2c893604e282"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "20px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "134d2527-80c7-456c-8b5c-c8b3cad4c4dd"
                                },
                                {
                                    "descriptor": {
                                        "button": {
                                            "href": "https://www.example.com",
                                            "label": "<div class=\"txtTinyMce-wrapper\" style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\" data-mce-style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\"><p style=\"font-size: 16px; line-height: 32px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif; word-break: break-word;\" data-mce-style=\"font-size: 16px; line-height: 32px;\">BROWSE NOW</p></div>",
                                            "style": {
                                                "background-color": "transparent",
                                                "border-bottom": "1px solid #8E364B",
                                                "border-left": "1px solid #8E364B",
                                                "border-radius": "4px",
                                                "border-right": "1px solid #8E364B",
                                                "border-top": "1px solid #8E364B",
                                                "color": "#8e364b",
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "5px",
                                                "padding-left": "20px",
                                                "padding-right": "20px",
                                                "padding-top": "5px",
                                                "width": "auto"
                                            }
                                        },
                                        "computedStyle": {
                                            "height": 44,
                                            "hideContentOnMobile": false,
                                            "width": 161
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px",
                                            "text-align": "center"
                                        },
                                        "text": {
                                            "style": {
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-button",
                                    "uuid": "d274b22d-ba06-46fc-94ae-604b432ca6ba"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "80px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "5c872dd1-196b-446b-af2b-90e17c4181cf"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "0px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "0px"
                            },
                            "uuid": "664350c9-da91-41d2-aba0-83e43a834556"
                        },
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth",
                                            "width": "720px"
                                        },
                                        "image": {
                                            "alt": "Featured Chair Banner Image Placeholder",
                                            "height": "613px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_mustardchair.png",
                                            "width": "900px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "be1d4ed7-2c86-41e2-bf5d-7f0aa330f685"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "0px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "0px"
                            },
                            "uuid": "3d570b99-5acf-4830-b1b0-ebfc7013592f"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#efe6d7",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "two-columns-empty",
                    "uuid": "27aba874-ae8a-4ef5-900e-c12576a81f0a"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "3094e063-3469-4179-899d-44049a240a39"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "0px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><span style=\"font-size: 30px; line-height: 36px; color: #323e49;\" data-mce-style=\"font-size: 30px; line-height: 36px; color: #323e49;\"><strong><span style=\"line-height: 14px;\" data-mce-style=\"line-height: 14px;\">FEATURED SEATING</span></strong></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "edd21664-9caf-4028-8252-591c6bae21c5"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "da0fe8c9-694d-440b-a907-6a4755c1a57c"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "199adc7d-b723-4868-8915-121ae9f2a4db"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#efe6d7",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "one-column-empty",
                    "uuid": "c8c33a05-2b89-4a83-adf0-910cca773f6c"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 4,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth",
                                            "width": "345px"
                                        },
                                        "image": {
                                            "alt": "Chair Image Placeholder",
                                            "height": "438px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_featuredseating_chair1.png",
                                            "width": "360px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "2be3d8f1-94ae-48e4-aeb8-4a6b158eeb4c"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "20px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><em><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\">Breakfast Chair</span></em></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "db931a50-0802-4622-aa7d-75f2af2c17a2"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "5px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><em><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\">£120</span></em></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "2672a5f9-554b-40a0-b28a-bdb20e4cc21c"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "10px solid #EFE6D7",
                                "border-left": "10px solid #EFE6D7",
                                "border-right": "10px solid #EFE6D7",
                                "border-top": "10px solid #EFE6D7",
                                "padding-bottom": "0px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "0px"
                            },
                            "uuid": "b4639143-8d35-47a8-bd74-caa26dce0453"
                        },
                        {
                            "grid-columns": 4,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth",
                                            "width": "345px"
                                        },
                                        "image": {
                                            "alt": "Chair Image Placeholder",
                                            "height": "438px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_featuredseating_chair2.png",
                                            "width": "359px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "405e7737-828e-48e5-8421-4850d9558cf7"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "20px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><em><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\">Grey Accent Chair</span></em></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "bc82ef73-70fd-4649-93df-5d8fa6f44e22"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "5px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><em><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\">£235</span></em></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "905178cb-d145-44cd-bc03-2e4d2e0d937e"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "10px solid #EFE6D7",
                                "border-left": "10px solid #EFE6D7",
                                "border-right": "10px solid #EFE6D7",
                                "border-top": "10px solid #EFE6D7",
                                "padding-bottom": "0px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "0px"
                            },
                            "uuid": "8ad9b3b3-5104-4932-8b2f-b262ef2595ca"
                        },
                        {
                            "grid-columns": 4,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth",
                                            "width": "345px"
                                        },
                                        "image": {
                                            "alt": "Chair Image Placeholder",
                                            "height": "438px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_featuredseating_chair3.png",
                                            "width": "359px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "44026c55-1182-4c89-8ae3-722366f30b66"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "20px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><em><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\">Orange Shell Chair</span></em></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "e62ef92a-76af-4c39-b46b-a4ee83643dc1"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "5px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><em><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\">£270</span></em></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "b4714441-26e3-49a0-8b88-bff3eb5ff932"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "10px solid #EFE6D7",
                                "border-left": "10px solid #EFE6D7",
                                "border-right": "10px solid #EFE6D7",
                                "border-top": "10px solid #EFE6D7",
                                "padding-bottom": "0px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "0px"
                            },
                            "uuid": "a92f53eb-13e1-4d9b-b467-985557c81b94"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#efe6d7",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "three-columns-empty",
                    "uuid": "27c390e5-6487-4b36-b95c-6f7fbfe65769"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "2cf3c588-45e6-4249-92b9-822b3bc8137a"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "199adc7d-b723-4868-8915-121ae9f2a4db"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#efe6d7",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "one-column-empty",
                    "uuid": "9c7cc923-5af1-465d-bafe-53ef57615045"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "0px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><strong><span style=\"font-size: 20px; line-height: 24px; color: #323e49;\" data-mce-style=\"font-size: 20px; line-height: 24px; color: #323e49;\">POPULAR CHOICES</span></strong></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "d4d0b999-3531-40b0-9978-4dc698e85069"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "10px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "5edd24a6-8432-4317-9666-cfa7accd42cf"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "0px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"line-height: 14px; word-break: break-word; text-align: left;\" data-mce-style=\"line-height: 14px; word-break: break-word; text-align: left;\"><span style=\"color: #323e49; line-height: 50px; font-size: 42px;\" data-mce-style=\"color: #323e49; line-height: 50px; font-size: 42px;\"><span style=\"line-height: 14px;\" data-mce-style=\"line-height: 14px;\"><strong>MODERN 3 SEATER<br>FABRIC SOFA</strong></span></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "3de59e2e-0cb0-4340-8b5e-367b3c24f944"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "10px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "9b0ef614-be8b-46d5-83c9-b739d2c4da7b"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit<br>sed diam nonummy nibh euismod tincidunt ut laoreet dolore.<br></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "d3fb7ddf-bd67-401f-94a2-b870932f8784"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "10px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "57fcb08b-4835-43d9-b6ea-3c43dd66aa8e"
                                },
                                {
                                    "descriptor": {
                                        "button": {
                                            "href": "https://www.example.com",
                                            "label": "<div class=\"txtTinyMce-wrapper\" style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\" data-mce-style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\"><p style=\"font-size: 16px; line-height: 32px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif; word-break: break-word;\" data-mce-style=\"font-size: 16px; line-height: 32px;\">BROWSE NOW</p></div>",
                                            "style": {
                                                "background-color": "transparent",
                                                "border-bottom": "1px solid #8E364B",
                                                "border-left": "1px solid #8E364B",
                                                "border-radius": "4px",
                                                "border-right": "1px solid #8E364B",
                                                "border-top": "1px solid #8E364B",
                                                "color": "#8e364b",
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "5px",
                                                "padding-left": "20px",
                                                "padding-right": "20px",
                                                "padding-top": "5px",
                                                "width": "auto"
                                            }
                                        },
                                        "computedStyle": {
                                            "height": 44,
                                            "hideContentOnMobile": false,
                                            "width": 161
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px",
                                            "text-align": "left"
                                        },
                                        "text": {
                                            "style": {
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-button",
                                    "uuid": "c2e00918-a8fe-477c-8d97-2dd74829a65b"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "0px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "0px"
                            },
                            "uuid": "95327066-fb55-419e-8862-f9ccea56d846"
                        },
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "right fixedwidth",
                                            "width": "720px"
                                        },
                                        "image": {
                                            "alt": "Sofa Image Placeholder",
                                            "height": "790px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_popularsofa_1.png",
                                            "width": "1290px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "eef4ef11-e87b-48ab-92cc-5d1d47e13e5e"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "c1358e3e-f070-43ec-826c-5aea0c636044"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "0px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "0px"
                            },
                            "uuid": "db554c80-c41b-4c07-a83b-b666b21fb523"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#f7f2eb",
                            "background-image": "url('https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_popularsofa_bg_1.png')",
                            "background-position": "center top",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "two-columns-empty",
                    "uuid": "2fb986a5-d8ea-44f8-b3f5-97ba3049c811"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "80px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "58f543d0-bfe5-433c-9be4-0c277c9ca9b3"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "right fixedwidth",
                                            "width": "720px"
                                        },
                                        "image": {
                                            "alt": "Sofa Image Placeholder",
                                            "height": "315px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_popularsofa_2.png",
                                            "width": "720px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "f72bb3fa-b6cf-435e-bae3-a9ea32741f73"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "65b87940-90d4-4220-bfaf-80b58ca2d737"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "0px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "0px"
                            },
                            "uuid": "95327066-fb55-419e-8862-f9ccea56d846"
                        },
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "0px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><strong><span style=\"font-size: 20px; line-height: 24px; color: #323e49;\" data-mce-style=\"font-size: 20px; line-height: 24px; color: #323e49;\">POPULAR COICES</span></strong></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "d65568d9-8eb7-48c3-a88e-d79a9bb0c630"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "10px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "d4312284-34cf-4cfa-9d62-609f88683d20"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "30px",
                                            "padding-right": "10px",
                                            "padding-top": "0px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"line-height: 14px; word-break: break-word; text-align: left;\" data-mce-style=\"line-height: 14px; word-break: break-word; text-align: left;\"><span style=\"color: #323e49; line-height: 50px; font-size: 42px;\" data-mce-style=\"color: #323e49; line-height: 50px; font-size: 42px;\"><span style=\"line-height: 14px;\" data-mce-style=\"line-height: 14px;\"><span style=\"line-height: 14px;\" data-mce-style=\"line-height: 14px;\"><strong>2 SEATER</strong></span></span></span></p><p style=\"line-height: 14px; word-break: break-word; text-align: left;\" data-mce-style=\"line-height: 14px; word-break: break-word; text-align: left;\"><span style=\"color: #323e49; line-height: 50px; font-size: 42px;\" data-mce-style=\"color: #323e49; line-height: 50px; font-size: 42px;\"><span style=\"line-height: 14px;\" data-mce-style=\"line-height: 14px;\"><span style=\"line-height: 14px;\" data-mce-style=\"line-height: 14px;\"><span style=\"line-height: 14px;\" data-mce-style=\"line-height: 14px;\"><strong>MICROSUEDE </strong></span></span></span><span style=\"line-height: 14px;\" data-mce-style=\"line-height: 14px;\"><span style=\"line-height: 14px;\" data-mce-style=\"line-height: 14px;\"><span style=\"line-height: 14px;\" data-mce-style=\"line-height: 14px;\"><strong>SOFA</strong></span></span></span></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "50f072a8-6597-408f-b039-6b9477977810"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "10px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "dde5795c-c218-4eb0-8bfe-5af776ece211"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit<br>sed diam nonummy nibh euismod tincidunt ut laoreet dolore.<br></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "7ef3b5ea-b2eb-41d1-889f-756630911c25"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "10px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "0a961544-308c-4b75-87a0-102619cae4bd"
                                },
                                {
                                    "descriptor": {
                                        "button": {
                                            "href": "https://www.example.com",
                                            "label": "<div class=\"txtTinyMce-wrapper\" style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\" data-mce-style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\"><p style=\"font-size: 16px; line-height: 32px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif; word-break: break-word;\" data-mce-style=\"font-size: 16px; line-height: 32px;\">BROWSE NOW</p></div>",
                                            "style": {
                                                "background-color": "transparent",
                                                "border-bottom": "1px solid #8E364B",
                                                "border-left": "1px solid #8E364B",
                                                "border-radius": "4px",
                                                "border-right": "1px solid #8E364B",
                                                "border-top": "1px solid #8E364B",
                                                "color": "#8e364b",
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "5px",
                                                "padding-left": "20px",
                                                "padding-right": "20px",
                                                "padding-top": "5px",
                                                "width": "auto"
                                            }
                                        },
                                        "computedStyle": {
                                            "height": 44,
                                            "hideContentOnMobile": false,
                                            "width": 161
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px",
                                            "text-align": "left"
                                        },
                                        "text": {
                                            "style": {
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-button",
                                    "uuid": "02847864-5e07-4a00-a23b-814f319b3ffe"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "0px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "0px"
                            },
                            "uuid": "db554c80-c41b-4c07-a83b-b666b21fb523"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#f7f2eb",
                            "background-image": "none",
                            "background-position": "center top",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "two-columns-empty",
                    "uuid": "220d4b5d-7500-4206-8f1a-a6d880b30a4d"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "80px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "c95edc8d-f224-416b-8105-181fd77e31e4"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "0px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><span style=\"font-size: 30px; line-height: 36px; color: #323e49;\" data-mce-style=\"font-size: 30px; line-height: 36px; color: #323e49;\"><strong><span style=\"line-height: 14px;\" data-mce-style=\"line-height: 14px;\">BROWSE DECOR SETS BY ROOMS</span></strong></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "f1b20bfe-4939-408a-9206-41dd5d343f91"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth",
                                            "width": "1224px"
                                        },
                                        "image": {
                                            "alt": "Console Table Placeholder",
                                            "height": "814px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/4726a794-4e35-400e-a9fe-f25bb5039e4b.png",
                                            "width": "1709px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "921766fb-38c3-4913-a53f-701216da70fa"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit<br>sed diam nonummy nibh euismod tincidunt ut laoreet dolore<br>aliquam erat volutpat. Ut wisi enim ad minim veniam, <br>quis nostrud exerci tation ullamcorper suscipit</span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "be6ec213-ec83-4ee8-9c38-2e4292b2ff91"
                                },
                                {
                                    "descriptor": {
                                        "button": {
                                            "href": "https://www.example.com",
                                            "label": "<div class=\"txtTinyMce-wrapper\" style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\" data-mce-style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\"><p style=\"font-size: 16px; line-height: 32px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif; word-break: break-word;\" data-mce-style=\"font-size: 16px; line-height: 32px;\">BROWSE NOW</p></div>",
                                            "style": {
                                                "background-color": "transparent",
                                                "border-bottom": "1px solid #8E364B",
                                                "border-left": "1px solid #8E364B",
                                                "border-radius": "4px",
                                                "border-right": "1px solid #8E364B",
                                                "border-top": "1px solid #8E364B",
                                                "color": "#8e364b",
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "5px",
                                                "padding-left": "20px",
                                                "padding-right": "20px",
                                                "padding-top": "5px",
                                                "width": "auto"
                                            }
                                        },
                                        "computedStyle": {
                                            "height": 44,
                                            "hideContentOnMobile": false,
                                            "width": 161
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px",
                                            "text-align": "center"
                                        },
                                        "text": {
                                            "style": {
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-button",
                                    "uuid": "37181de6-e305-4edd-a13a-2009ad05347c"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "50px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "7800d698-5ee5-4116-bb49-3d734b65f12a"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "10px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "d3ba18b6-c894-499a-84d2-56b881138303"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "0px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "0px"
                            },
                            "uuid": "c9ff8034-141d-4a0d-b651-cb984e96e143"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#f7f2eb",
                            "background-image": "url('https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_tvstand_bg_1.png')",
                            "background-position": "top center",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "one-column-empty",
                    "uuid": "bb3630fa-22df-4281-b2a7-ab8665f9d11f"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 3,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "4312c73a-add3-42e0-9e95-7be636cdb6b4"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "0px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><span style=\"font-size: 30px; line-height: 36px;\" data-mce-style=\"font-size: 30px; line-height: 36px;\"><strong><span style=\"line-height: 14px; color: #323e49;\" data-mce-style=\"line-height: 14px; color: #323e49;\">ACCESSORIES</span></strong></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "3f6dfed0-41f9-4faf-b289-8af44cfd8995"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth",
                                            "width": "340px"
                                        },
                                        "image": {
                                            "alt": "Accessories Placeholder",
                                            "height": "488px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_cushions_1.png",
                                            "width": "640px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "a0338601-c233-4896-9eec-b4f8ce775219"
                                },
                                {
                                    "descriptor": {
                                        "button": {
                                            "href": "https://www.example.com",
                                            "label": "<div class=\"txtTinyMce-wrapper\" style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\" data-mce-style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\"><p style=\"font-size: 16px; line-height: 32px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif; word-break: break-word;\" data-mce-style=\"font-size: 16px; line-height: 32px;\">BROWSE NOW</p></div>",
                                            "style": {
                                                "background-color": "transparent",
                                                "border-bottom": "1px solid #8E364B",
                                                "border-left": "1px solid #8E364B",
                                                "border-radius": "4px",
                                                "border-right": "1px solid #8E364B",
                                                "border-top": "1px solid #8E364B",
                                                "color": "#8e364b",
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "5px",
                                                "padding-left": "20px",
                                                "padding-right": "20px",
                                                "padding-top": "5px",
                                                "width": "auto"
                                            }
                                        },
                                        "computedStyle": {
                                            "height": 44,
                                            "hideContentOnMobile": false,
                                            "width": 161
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px",
                                            "text-align": "center"
                                        },
                                        "text": {
                                            "style": {
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-button",
                                    "uuid": "0530baaf-0464-418b-b067-3ba4563e1a9c"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "3703e7a5-c2d9-4adc-89ae-fb0759759e22"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "0px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><span style=\"font-size: 30px; line-height: 36px;\" data-mce-style=\"font-size: 30px; line-height: 36px;\"><strong><span style=\"line-height: 14px; color: #323e49;\" data-mce-style=\"line-height: 14px; color: #323e49;\">LAMPS</span></strong></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "f160dd21-b4ce-4e6d-afee-159f6d0fb22d"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth",
                                            "width": "187px"
                                        },
                                        "image": {
                                            "alt": "Lamp Placeholder",
                                            "height": "1592px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/fc_lamps.png",
                                            "width": "1096px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "e2604de7-f8b0-45a0-9e24-961d9919d2a4"
                                },
                                {
                                    "descriptor": {
                                        "button": {
                                            "href": "https://www.example.com",
                                            "label": "<div class=\"txtTinyMce-wrapper\" style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\" data-mce-style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\"><p style=\"font-size: 16px; line-height: 32px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif; word-break: break-word;\" data-mce-style=\"font-size: 16px; line-height: 32px;\">BROWSE NOW</p></div>",
                                            "style": {
                                                "background-color": "transparent",
                                                "border-bottom": "1px solid #8E364B",
                                                "border-left": "1px solid #8E364B",
                                                "border-radius": "4px",
                                                "border-right": "1px solid #8E364B",
                                                "border-top": "1px solid #8E364B",
                                                "color": "#8e364b",
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "5px",
                                                "padding-left": "20px",
                                                "padding-right": "20px",
                                                "padding-top": "5px",
                                                "width": "auto"
                                            }
                                        },
                                        "computedStyle": {
                                            "height": 44,
                                            "hideContentOnMobile": false,
                                            "width": 161
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px",
                                            "text-align": "center"
                                        },
                                        "text": {
                                            "style": {
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-button",
                                    "uuid": "525bd424-b51e-4b0b-9fe4-036ee1b07b11"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "7e278ee9-36f1-4735-a286-899acac0240e"
                                }
                            ],
                            "style": {
                                "background-color": "#f7f2eb",
                                "border-bottom": "10px solid #EFE6D7",
                                "border-left": "10px solid #EFE6D7",
                                "border-right": "10px solid #EFE6D7",
                                "border-top": "10px solid #EFE6D7",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "c0d2b968-010e-45dc-af11-4a8a3c6faa6c"
                        },
                        {
                            "grid-columns": 3,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "cbe06cec-9131-46b7-8829-ee3044c657ae"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "0px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><span style=\"font-size: 30px; line-height: 36px;\" data-mce-style=\"font-size: 30px; line-height: 36px;\"><strong><span style=\"line-height: 14px; color: #323e49;\" data-mce-style=\"line-height: 14px; color: #323e49;\">SIDE TABLES</span></strong></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "3d2ae0c0-2ab4-4f1e-bf8d-9a7539299f69"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth",
                                            "width": "255px"
                                        },
                                        "image": {
                                            "alt": "Side Coffee Tables Placeholder",
                                            "height": "1023px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/coffeetables.png",
                                            "width": "1000px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "1a1e3469-f89d-49e4-8e2a-4417b817fda9"
                                },
                                {
                                    "descriptor": {
                                        "button": {
                                            "href": "https://www.example.com",
                                            "label": "<div class=\"txtTinyMce-wrapper\" style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\" data-mce-style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\"><p style=\"font-size: 16px; line-height: 32px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif; word-break: break-word;\" data-mce-style=\"font-size: 16px; line-height: 32px;\">BROWSE NOW</p></div>",
                                            "style": {
                                                "background-color": "transparent",
                                                "border-bottom": "1px solid #8E364B",
                                                "border-left": "1px solid #8E364B",
                                                "border-radius": "4px",
                                                "border-right": "1px solid #8E364B",
                                                "border-top": "1px solid #8E364B",
                                                "color": "#8e364b",
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "5px",
                                                "padding-left": "20px",
                                                "padding-right": "20px",
                                                "padding-top": "5px",
                                                "width": "auto"
                                            }
                                        },
                                        "computedStyle": {
                                            "height": 44,
                                            "hideContentOnMobile": false,
                                            "width": 161
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px",
                                            "text-align": "center"
                                        },
                                        "text": {
                                            "style": {
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-button",
                                    "uuid": "3aa7e98f-dc48-492f-b4d9-5e41db4116dc"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "9f2c6dc7-ed92-4a28-aec2-183d7e999cab"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "0px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><span style=\"font-size: 30px; line-height: 36px;\" data-mce-style=\"font-size: 30px; line-height: 36px;\"><strong><span style=\"line-height: 14px; color: #323e49;\" data-mce-style=\"line-height: 14px; color: #323e49;\">DECORATION</span></strong></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "017fa10f-06f1-4480-975c-438a2b3263f2"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth",
                                            "width": "323px"
                                        },
                                        "image": {
                                            "alt": "Decor Placeholder",
                                            "height": "850px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_decoarations.png",
                                            "width": "1000px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "8959d14b-9a6a-45c4-8d91-f204419e9818"
                                },
                                {
                                    "descriptor": {
                                        "button": {
                                            "href": "https://www.example.com",
                                            "label": "<div class=\"txtTinyMce-wrapper\" style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\" data-mce-style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\"><p style=\"font-size: 16px; line-height: 32px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif; word-break: break-word;\" data-mce-style=\"font-size: 16px; line-height: 32px;\">BROWSE NOW</p></div>",
                                            "style": {
                                                "background-color": "transparent",
                                                "border-bottom": "1px solid #8E364B",
                                                "border-left": "1px solid #8E364B",
                                                "border-radius": "4px",
                                                "border-right": "1px solid #8E364B",
                                                "border-top": "1px solid #8E364B",
                                                "color": "#8e364b",
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "5px",
                                                "padding-left": "20px",
                                                "padding-right": "20px",
                                                "padding-top": "5px",
                                                "width": "auto"
                                            }
                                        },
                                        "computedStyle": {
                                            "height": 44,
                                            "hideContentOnMobile": false,
                                            "width": 161
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "5px",
                                            "text-align": "center"
                                        },
                                        "text": {
                                            "style": {
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-button",
                                    "uuid": "685c87ae-5e3a-45bd-96b8-5f8484f41b3b"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "6f45e2e0-d2c4-41de-beee-c1d0a203a758"
                                }
                            ],
                            "style": {
                                "background-color": "#f7f2eb",
                                "border-bottom": "10px solid #EFE6D7",
                                "border-left": "10px solid #EFE6D7",
                                "border-right": "10px solid #EFE6D7",
                                "border-top": "10px solid #EFE6D7",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "e1e9291f-aa3e-4cd9-a9eb-21f5953603f8"
                        },
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "13ea9976-f279-428a-9bd4-9d11ababd413"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "0px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><span style=\"font-size: 30px; line-height: 36px;\" data-mce-style=\"font-size: 30px; line-height: 36px;\"><strong><span style=\"line-height: 14px; color: #323e49;\" data-mce-style=\"line-height: 14px; color: #323e49;\">LIVING ROOM</span></strong></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "afe0f4c6-8438-4fc7-a3aa-f478e827ce44"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "left fixedwidth",
                                            "width": "560px"
                                        },
                                        "image": {
                                            "alt": "Living Room Setting Placeholder",
                                            "height": "1169px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/bronze_sofa_XL.png",
                                            "width": "1000px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "82758681-d0ac-4830-b395-73939b8edf46"
                                },
                                {
                                    "descriptor": {
                                        "button": {
                                            "href": "https://www.example.com",
                                            "label": "<div class=\"txtTinyMce-wrapper\" style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\" data-mce-style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\"><p style=\"font-size: 16px; line-height: 32px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif; word-break: break-word;\" data-mce-style=\"font-size: 16px; line-height: 32px;\">BROWSE NOW</p></div>",
                                            "style": {
                                                "background-color": "transparent",
                                                "border-bottom": "1px solid #8E364B",
                                                "border-left": "1px solid #8E364B",
                                                "border-radius": "4px",
                                                "border-right": "1px solid #8E364B",
                                                "border-top": "1px solid #8E364B",
                                                "color": "#8e364b",
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "5px",
                                                "padding-left": "20px",
                                                "padding-right": "20px",
                                                "padding-top": "5px",
                                                "width": "auto"
                                            }
                                        },
                                        "computedStyle": {
                                            "height": 44,
                                            "hideContentOnMobile": false,
                                            "width": 161
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "15px",
                                            "text-align": "center"
                                        },
                                        "text": {
                                            "style": {
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-button",
                                    "uuid": "093ceeef-ebb7-4607-a98f-d8e33ee9b327"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "dd829f92-4166-4aa3-b1c1-830f7a4e06d4"
                                }
                            ],
                            "style": {
                                "background-color": "#f7f2eb",
                                "border-bottom": "10px solid #EFE6D7",
                                "border-left": "10px solid #EFE6D7",
                                "border-right": "10px solid #EFE6D7",
                                "border-top": "10px solid #EFE6D7",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "e2cf409b-440e-4c94-b75c-82fbc5d7c64b"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#efe6d7",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "three-columns-3-3-6-empty",
                    "uuid": "c53b9a7f-13ac-4273-a0d3-c7e89724b168"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "50px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "4d56ee30-301b-4f71-9ef2-060cd88c4840"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "0px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "0px"
                            },
                            "uuid": "c8ee61d2-8a83-4eee-a269-0e72bf23907b"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#efe6d7",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "one-column-empty",
                    "uuid": "fa11139f-853d-4379-b099-d4952637d892"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 3,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth",
                                            "width": "90px"
                                        },
                                        "image": {
                                            "alt": "Round Pod Chair Sides Placeholder ",
                                            "height": "120px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_eggchair_details1.png",
                                            "width": "90px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "6b852f56-6315-4b50-bfb3-09366b7af44c"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "10px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "7d7d33d5-2ee1-4a02-9be4-556ffea01112"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth",
                                            "width": "108px"
                                        },
                                        "image": {
                                            "alt": "Round Pod Chair Sides Placeholder ",
                                            "height": "120px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_eggchair_details2.png",
                                            "width": "102px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "cc371c7e-919e-4eae-b4e9-8ebb93f316ae"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "10px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "35ebc85e-d928-4431-888c-f51e28e8fc9c"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth",
                                            "width": "106px"
                                        },
                                        "image": {
                                            "alt": "Round Pod Chair Sides Placeholder ",
                                            "height": "120px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_eggchair_details3.png",
                                            "width": "106px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "e06e2daf-38e5-4927-a65f-1024e38831b4"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "bca3a5d3-007e-4517-88db-a9ec995cce92"
                        },
                        {
                            "grid-columns": 3,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "290d3256-438e-4580-90eb-124dc703a635"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth",
                                            "width": "360px"
                                        },
                                        "image": {
                                            "alt": "Round Pod Chair Placeholder",
                                            "height": "853px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/65616fad-6995-4f67-ac06-e66548fb3b32.png",
                                            "width": "1000px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "0f808e6a-137c-4724-9188-3c5a23ac8b23"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "585eea02-ad35-41ed-b2aa-b63f23f0652a"
                        },
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "80px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "24a7b899-510c-47b9-99d1-d95d5ae574a2"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "0px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><strong><span style=\"font-size: 20px; line-height: 24px; color: #323e49;\" data-mce-style=\"font-size: 20px; line-height: 24px; color: #323e49;\">DESIGNER PICKS</span></strong></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "4f402bb4-6297-43c7-9a5f-7b817a1a6eeb"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "10px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "d8e91869-4cf5-479f-b637-fbb4d4a7be2f"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "0px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><span style=\"font-size: 30px; line-height: 36px;\" data-mce-style=\"font-size: 30px; line-height: 36px;\"><strong><span style=\"line-height: 14px; color: #323e49;\" data-mce-style=\"line-height: 14px; color: #323e49;\">LOUNGE POD CHAIR</span></strong></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "2b7d1301-fee0-403a-a7ce-d47e4db29d0c"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit<br>sed diam nonummy nibh euismod tincidunt ut laoreet dolore.<br></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "ff330768-2ca9-40d6-ad8e-f60efb321132"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "10px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "2f6ba13c-e6eb-440a-87c1-70f5a7443507"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "5px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><em><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\">£850</span></em></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "a9466987-df88-48a5-9e6c-a1c28b1f1dd6"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "10px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "70f8f145-d1d1-4327-b9c2-1d919363fa35"
                                },
                                {
                                    "descriptor": {
                                        "button": {
                                            "href": "https://www.example.com",
                                            "label": "<div class=\"txtTinyMce-wrapper\" style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\" data-mce-style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\"><p style=\"font-size: 16px; line-height: 32px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif; word-break: break-word;\" data-mce-style=\"font-size: 16px; line-height: 32px;\">BROWSE NOW</p></div>",
                                            "style": {
                                                "background-color": "transparent",
                                                "border-bottom": "1px solid #8E364B",
                                                "border-left": "1px solid #8E364B",
                                                "border-radius": "4px",
                                                "border-right": "1px solid #8E364B",
                                                "border-top": "1px solid #8E364B",
                                                "color": "#8e364b",
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "5px",
                                                "padding-left": "20px",
                                                "padding-right": "20px",
                                                "padding-top": "5px",
                                                "width": "auto"
                                            }
                                        },
                                        "computedStyle": {
                                            "height": 44,
                                            "hideContentOnMobile": false,
                                            "width": 161
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px",
                                            "text-align": "left"
                                        },
                                        "text": {
                                            "style": {
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-button",
                                    "uuid": "4ebd4d4d-6523-4c77-842a-d843ef29d67f"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "ab251857-6ad2-40aa-b4fd-ef729e432580"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#efe6d7",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "three-columns-3-3-6-empty",
                    "uuid": "7e60ef1e-a972-4177-acef-ff8c0d040480"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "50px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "66037b69-0dba-46a1-b3c4-e3cdeeb4bb42"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "0px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "0px"
                            },
                            "uuid": "c8ee61d2-8a83-4eee-a269-0e72bf23907b"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#efe6d7",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "one-column-empty",
                    "uuid": "5dc6f356-4023-4d88-a86d-11857a782b6d"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "50px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "a8b84d08-ac58-4e1e-bb25-d45f1aceaafd"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "0px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "0px"
                            },
                            "uuid": "c8ee61d2-8a83-4eee-a269-0e72bf23907b"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#f7f2eb",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "one-column-empty",
                    "uuid": "095c5b6c-e673-4803-8059-b61941522a42"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 3,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth",
                                            "width": "90px"
                                        },
                                        "image": {
                                            "alt": "Customer Service Icon Placeholder",
                                            "height": "164px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_PERKS_CS_ICON.png",
                                            "width": "157px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "74223eba-6522-40bd-ae8e-cd8b4b070b21"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "20px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "8ed612fc-9e4d-4df5-b2a9-343f1f5d47f9"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><strong><span style=\"font-size: 20px; line-height: 24px; color: #323e49;\" data-mce-style=\"font-size: 20px; line-height: 24px; color: #323e49;\">24h SERVICE</span></strong></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "a70f2799-6963-4223-8562-951040152540"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "25b222be-4354-4691-88b2-7092448eafe6"
                        },
                        {
                            "grid-columns": 3,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth",
                                            "width": "126px"
                                        },
                                        "image": {
                                            "alt": "Returns Icon Placeholder",
                                            "height": "154px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_PERKS_FR_ICON.png",
                                            "width": "221px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "27283a93-bc56-4cda-9d3e-df253487ba84"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "20px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "92c29e39-3f38-44ef-b2ea-0508f7df9f3f"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><strong><span style=\"font-size: 20px; line-height: 24px; color: #323e49;\" data-mce-style=\"font-size: 20px; line-height: 24px; color: #323e49;\">FREE RETURNS</span></strong></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "38958f23-0936-4022-bf5a-b6a3043b1e41"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "68304cbc-67aa-49aa-8def-d6e26455bf84"
                        },
                        {
                            "grid-columns": 3,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth",
                                            "width": "144px"
                                        },
                                        "image": {
                                            "alt": "Tracking Icon Placeholder",
                                            "height": "167px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_PERKS_TR_ICON.png",
                                            "width": "262px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "ef2195a1-ee8f-400e-972d-625c73c3ca4e"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "20px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "51982b57-9d1b-4e44-9ebf-bc61707b4bed"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><strong><span style=\"font-size: 20px; line-height: 24px; color: #323e49;\" data-mce-style=\"font-size: 20px; line-height: 24px; color: #323e49;\">ORDER TRACKING</span></strong></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "afb40225-4a51-43f4-9cc3-22d712a6219b"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "b27b9fe8-0797-45e2-9e5b-5f53dcb71167"
                        },
                        {
                            "grid-columns": 3,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth",
                                            "width": "108px"
                                        },
                                        "image": {
                                            "alt": "Delivery Icon Placeholder",
                                            "height": "191px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_PERKS_FD_ICON.png",
                                            "width": "200px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "daee818c-da18-425b-ae52-4cd212b6e267"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "20px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "8bdd0cb5-c324-4eea-a4a5-77c5d9e3ee1f"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><strong><span style=\"font-size: 20px; line-height: 24px; color: #323e49;\" data-mce-style=\"font-size: 20px; line-height: 24px; color: #323e49;\">FAST DELIVERY</span></strong></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "17753e7d-30ec-4253-95be-d0dcfcabbd3e"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "3ea8f040-7867-4162-a1c8-fce86278b7dc"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#f7f2eb",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "four-columns-empty",
                    "uuid": "40783ebd-93b7-4d41-a27b-83a00e941669"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "50px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "2543d9de-9c42-45ff-9d8a-f3f89b7a2c6e"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "0px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "0px"
                            },
                            "uuid": "c8ee61d2-8a83-4eee-a269-0e72bf23907b"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#f7f2eb",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "one-column-empty",
                    "uuid": "4e6da92d-0643-4849-b522-ada2a7b5350b"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "50px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "da4c217b-ef13-417d-bbbd-68624cc1fbaa"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "0px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><span style=\"font-size: 30px; line-height: 36px; color: #323e49;\" data-mce-style=\"font-size: 30px; line-height: 36px; color: #323e49;\"><strong><span style=\"line-height: 14px;\" data-mce-style=\"line-height: 14px;\">REIMAGINING THE CLASSICS</span></strong></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "da5b33b2-d17c-4046-ae32-759eeecf73ba"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "20px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "992b2e0e-1b22-4768-b8c7-d50e7ad6da91"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: center;\"><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit sed diam nonummy nibh <br>euismod tincidunt ut laoreet dolorealiquam erat volutpat. Ut wisi enim ad minim veniam, <br>quis nostrud exerci tation ullamcorper suscipit</span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "dde8464d-2632-483a-93a4-e92c70eefd97"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "b7d5f5f1-5a27-48ab-a62d-8629dc202b5b"
                                },
                                {
                                    "descriptor": {
                                        "button": {
                                            "href": "https://www.example.com",
                                            "label": "<div class=\"txtTinyMce-wrapper\" style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\" data-mce-style=\"font-size: 12px; line-height: 24px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif;\"><p style=\"font-size: 16px; line-height: 32px; font-family: Montserrat, &apos;Trebuchet MS&apos;, &apos;Lucida Grande&apos;, &apos;Lucida Sans Unicode&apos;, &apos;Lucida Sans&apos;, Tahoma, sans-serif; word-break: break-word;\" data-mce-style=\"font-size: 16px; line-height: 32px;\">BROWSE NOW</p></div>",
                                            "style": {
                                                "background-color": "transparent",
                                                "border-bottom": "1px solid #8E364B",
                                                "border-left": "1px solid #8E364B",
                                                "border-radius": "4px",
                                                "border-right": "1px solid #8E364B",
                                                "border-top": "1px solid #8E364B",
                                                "color": "#8e364b",
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                                                "line-height": "200%",
                                                "max-width": "100%",
                                                "padding-bottom": "5px",
                                                "padding-left": "20px",
                                                "padding-right": "20px",
                                                "padding-top": "5px",
                                                "width": "auto"
                                            }
                                        },
                                        "computedStyle": {
                                            "height": 44,
                                            "hideContentOnMobile": false,
                                            "width": 161
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px",
                                            "text-align": "center"
                                        },
                                        "text": {
                                            "style": {
                                                "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-button",
                                    "uuid": "10b77547-a92b-4374-b8c8-6cf02a1ffe80"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "30px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "4ea58200-50b6-4c16-af17-58dfb2b81447"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center autowidth",
                                            "hideContentOnMobile": false,
                                            "width": "680px"
                                        },
                                        "image": {
                                            "alt": "Classics Seating Set Placeholder",
                                            "height": "265px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/FC_classics_sofa.png",
                                            "width": "680px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "6a2ef4fe-e13d-4b07-a40d-8df4f4260a1e"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "80px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "cf691d99-bc32-4074-ae19-db75706fc5a2"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "0px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "0px"
                            },
                            "uuid": "c8ee61d2-8a83-4eee-a269-0e72bf23907b"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#efe6d7",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "one-column-empty",
                    "uuid": "ccb79f23-c2a8-40a0-be8b-7b3bdc5a4eb1"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "0px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><span style=\"font-size: 20px; line-height: 24px; color: #323e49;\" data-mce-style=\"font-size: 20px; line-height: 24px; color: #323e49;\"><strong><span style=\"line-height: 14px;\" data-mce-style=\"line-height: 14px;\">SIGN UP NOW TO RECEIVE EXTRA DISCOUNTS AND PROMOTIONS FROM US!</span></strong></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "e00d5212-b91d-4728-8ce6-0c5c3cffa6c2"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "10px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "0700f127-6991-4daa-9a2f-aceeb4f3f6f9"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit sed diam nonummy nibh <br>euismod tincidunt ut laoreet dolorealiquam erat volutpat. Ut wisi enim ad minim veniam, <br>quis nostrud exerci tation ullamcorper suscipit.</span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "9c458006-e82c-47ff-abe7-573792996a74"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center fixedwidth",
                                            "width": "324px"
                                        },
                                        "image": {
                                            "alt": "Modern Chair Set Placeholder",
                                            "height": "1295px",
                                            "href": "",
                                            "src": "https://d1oco4z2z1fhwp.cloudfront.net/templates/default/2416/armchair2.png",
                                            "width": "1920px"
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-image",
                                    "uuid": "c6058566-5acb-4fec-aee8-d11e1565b25f"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "981ed420-cc94-4de8-8c62-745ad5617181"
                        },
                        {
                            "grid-columns": 6,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "15px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "86199bbb-86d3-4456-b8c4-bac16f3531da"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "class": "center",
                                            "hideContentOnDesktop": false,
                                            "hideContentOnMobile": false
                                        },
                                        "form": {
                                            "attributes": [],
                                            "structure": {
                                                "attributes": {
                                                    "accept-charset": "UTF-8",
                                                    "action": "{{form.action}}",
                                                    "autocomplete": "on",
                                                    "enctype": "multipart/form-data",
                                                    "method": "post",
                                                    "novalidate": false,
                                                    "target": "_self"
                                                },
                                                "description": "A BEE sample form",
                                                "fields": {
                                                    "email": {
                                                        "attributes": {
                                                            "name": "{{form.email}}",
                                                            "required": true
                                                        },
                                                        "canBeRemovedFromLayout": false,
                                                        "label": "Email",
                                                        "type": "text"
                                                    },
                                                    "firstname": {
                                                        "attributes": {
                                                            "name": "{{form.firstname}}",
                                                            "required": true
                                                        },
                                                        "canBeRemovedFromLayout": true,
                                                        "label": "First Name",
                                                        "type": "text"
                                                    },
                                                    "lastname": {
                                                        "attributes": {
                                                            "name": "{{form.lastname}}",
                                                            "required": true
                                                        },
                                                        "canBeRemovedFromLayout": true,
                                                        "label": "Last Name",
                                                        "type": "text"
                                                    },
                                                    "privacy": {
                                                        "attributes": {
                                                            "name": "{{form.privacy_policy}}"
                                                        },
                                                        "canBeRemovedFromLayout": true,
                                                        "label": "I agree to the [Privacy Policy](#form.privacyurl)",
                                                        "type": "checkbox"
                                                    },
                                                    "submit": {
                                                        "attributes": {
                                                            "value": "SIGN UP"
                                                        },
                                                        "canBeRemovedFromLayout": false,
                                                        "label": "",
                                                        "type": "submit"
                                                    }
                                                },
                                                "layout": [
                                                    [
                                                        "firstname"
                                                    ],
                                                    [
                                                        "lastname"
                                                    ],
                                                    [
                                                        "email"
                                                    ],
                                                    [
                                                        "privacy"
                                                    ],
                                                    [
                                                        "submit"
                                                    ]
                                                ],
                                                "title": "Login form"
                                            },
                                            "style": {
                                                "buttons": {
                                                    "backgroundColor": "transparent",
                                                    "border-bottom": "1px solid #8E364B",
                                                    "border-left": "1px solid #8E364B",
                                                    "border-radius": "4px",
                                                    "border-right": "1px solid #8E364B",
                                                    "border-top": "1px solid #8E364B",
                                                    "color": "#8e364b",
                                                    "line-height": "200%",
                                                    "max-width": "100%",
                                                    "outer": {
                                                        "display": "flex",
                                                        "flexGrow": 1,
                                                        "padding-buttom": "0px",
                                                        "padding-left": "0px",
                                                        "padding-right": "0px",
                                                        "padding-top": "0px"
                                                    },
                                                    "padding-bottom": "5px",
                                                    "padding-left": "20px",
                                                    "padding-right": "20px",
                                                    "padding-top": "5px",
                                                    "text-align": "center",
                                                    "width": "100%"
                                                },
                                                "fields": {
                                                    "backgroundColor": "#f7f2eb",
                                                    "border-bottom": "1px solid transparent",
                                                    "border-left": "1px solid transparent",
                                                    "border-radius": "4px",
                                                    "border-right": "1px solid transparent",
                                                    "border-top": "1px solid transparent",
                                                    "color": "#323e49",
                                                    "outlineColor": "#8e364b",
                                                    "padding-bottom": "5px",
                                                    "padding-left": "5px",
                                                    "padding-right": "5px",
                                                    "padding-top": "5px"
                                                },
                                                "labels": {
                                                    "color": "#323e49",
                                                    "font-style": "",
                                                    "font-weight": "",
                                                    "label-position": "top",
                                                    "line-height": "200%",
                                                    "text-align": "left"
                                                }
                                            }
                                        },
                                        "style": {
                                            "background-color": "transparent",
                                            "font-family": "'Montserrat', 'Trebuchet MS', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', Tahoma, sans-serif",
                                            "font-size": "14px",
                                            "padding-bottom": "10px",
                                            "padding-left": "10px",
                                            "padding-right": "10px",
                                            "padding-top": "10px",
                                            "text-align": "center",
                                            "width": "100%"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-form",
                                    "uuid": "1921ea8a-f7da-4fb6-b51a-3cf3078a5f77"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "2fd35252-0679-4ad9-bec9-bc32d2c27ffa"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#efe6d7",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "two-columns-empty",
                    "uuid": "2a7c847b-cd7a-43cb-bd67-9c34e2b37db6"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "80px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "41733633-5e33-4f7b-a1ae-29e490230e36"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "0px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "0px"
                            },
                            "uuid": "c8ee61d2-8a83-4eee-a269-0e72bf23907b"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#efe6d7",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "one-column-empty",
                    "uuid": "d3761aed-8e50-4f6e-af62-3960f2809358"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 3,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\"><span style=\"font-size: 20px; line-height: 24px;\" data-mce-style=\"font-size: 20px; line-height: 24px;\"><strong>CONTACT</strong></span></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "61717942-dd4d-48cf-b7ee-5a9124619823"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\">+1234 567 890</span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "95d3e3c9-bfde-41d6-aafd-aaee55ded090"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "5px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\">123 Street, London</span></p><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\">United Kingdom<br>E3 15UB</span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "df6f1da3-9f53-4887-972d-dfc71153bc46"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "height": 57,
                                            "hideContentOnMobile": false,
                                            "iconsDefaultWidth": 32,
                                            "padding": "0 5px 0 5px",
                                            "width": 151
                                        },
                                        "iconsList": {
                                            "icons": [
                                                {
                                                    "image": {
                                                        "alt": "Facebook",
                                                        "href": "https://www.example.com",
                                                        "prefix": "facebook",
                                                        "src": "https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-outline-circle-dark-gray/facebook@2x.png",
                                                        "title": "facebook"
                                                    },
                                                    "name": "facebook",
                                                    "text": "",
                                                    "type": "follow"
                                                },
                                                {
                                                    "image": {
                                                        "alt": "Twitter",
                                                        "href": "https://www.example.com",
                                                        "prefix": "twitter",
                                                        "src": "https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-outline-circle-dark-gray/twitter@2x.png",
                                                        "title": "twitter"
                                                    },
                                                    "name": "twitter",
                                                    "text": "",
                                                    "type": "follow"
                                                },
                                                {
                                                    "image": {
                                                        "alt": "Linkedin",
                                                        "href": "https://www.example.com",
                                                        "prefix": "linkedin",
                                                        "src": "https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-outline-circle-dark-gray/linkedin@2x.png",
                                                        "title": "linkedin"
                                                    },
                                                    "name": "linkedin",
                                                    "text": "",
                                                    "type": "follow"
                                                },
                                                {
                                                    "image": {
                                                        "alt": "Instagram",
                                                        "href": "https://www.example.com",
                                                        "prefix": "instagram",
                                                        "src": "https://app-rsrc.getbee.io/public/resources/social-networks-icon-sets/t-outline-circle-dark-gray/instagram@2x.png",
                                                        "title": "instagram"
                                                    },
                                                    "name": "instagram",
                                                    "text": "",
                                                    "type": "follow"
                                                }
                                            ]
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "10px",
                                            "padding-top": "10px",
                                            "text-align": "left"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-social",
                                    "uuid": "805bede3-ba29-4df8-bcc9-96fd71a1838a"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "0fcf2c7a-d5f7-4ac2-862e-aad734a91926"
                        },
                        {
                            "grid-columns": 3,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\"><span style=\"font-size: 20px; line-height: 24px;\" data-mce-style=\"font-size: 20px; line-height: 24px;\"><strong>HELP</strong></span></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "b215a0b6-dc45-4e5e-b677-61b113472810"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><a style=\"text-decoration: none;\" href=\"https://www.example.com\" target=\"_blank\" rel=\"noopener\">FAQs</a></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "992b4d47-37c0-4bdb-9597-cfe25258c61e"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "5px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><a style=\"text-decoration: none;\" href=\"https://www.example.com\" target=\"_blank\" rel=\"noopener\">Pricing Plans</a></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "1428e0d3-5825-43ff-ad8c-04503463afbb"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "5px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><a style=\"text-decoration: none;\" href=\"https://www.example.com\" target=\"_blank\" rel=\"noopener\">Track</a></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "d251836f-759c-412c-a368-a58ac41e9eab"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "5px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><a style=\"text-decoration: none;\" href=\"https://www.example.com\" target=\"_blank\" rel=\"noopener\">My Order</a></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "21cce906-d997-45ab-ba38-d10dc6a78b38"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "5px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><a style=\"text-decoration: none;\" href=\"https://www.example.com\" target=\"_blank\" rel=\"noopener\">My Account</a></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "fcac5d0a-32e4-4c90-814d-7a6916512881"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "89cb4df1-a198-40be-80af-706ce6d3e686"
                        },
                        {
                            "grid-columns": 3,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\"><span style=\"font-size: 20px; line-height: 24px;\" data-mce-style=\"font-size: 20px; line-height: 24px;\"><strong>ABOUT US</strong></span></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "f65e69a2-0b62-4413-91f6-aa7fc2e2adf0"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><a style=\"text-decoration: none;\" href=\"https://www.example.com\" target=\"_blank\" rel=\"noopener\">Our Story</a></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "81b341f4-75fa-47aa-a609-17b68c29c187"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "5px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><a style=\"text-decoration: none;\" href=\"https://www.example.com\" target=\"_blank\" rel=\"noopener\">Job Opportunities</a></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "5a3f8a23-18ef-4b5b-9830-f9b17b717da0"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "5px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><a style=\"text-decoration: none;\" href=\"https://www.example.com\" target=\"_blank\" rel=\"noopener\">Store Locator</a></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "c1d26cee-328b-4089-a342-5e2516e56ad7"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "5px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><a style=\"text-decoration: none;\" href=\"https://www.example.com\" target=\"_blank\" rel=\"noopener\">Blog</a></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "62be6c8c-1fa8-46b3-b76d-5a00118de52a"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "539276bc-98fa-4070-b1b8-9e1aa18e4adc"
                        },
                        {
                            "grid-columns": 3,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "10px",
                                            "padding-left": "30px",
                                            "padding-right": "10px",
                                            "padding-top": "10px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word;\"><span style=\"color: #323e49; line-height: 14px;\" data-mce-style=\"color: #323e49; line-height: 14px;\"><span style=\"font-size: 20px; line-height: 24px;\" data-mce-style=\"font-size: 20px; line-height: 24px;\"><strong>CUSTOMER SERVICE</strong></span></span></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "7569cc03-51c1-47ff-b53b-422d380246b1"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "10px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><a style=\"text-decoration: none;\" href=\"https://www.example.com\" target=\"_blank\" rel=\"noopener\">Settings</a></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "1139ce39-903e-4a45-a4ca-5e6e22e8f6bf"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "5px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><a style=\"text-decoration: none;\" href=\"https://www.example.com\" target=\"_blank\" rel=\"noopener\">Terms of Use</a></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "b4900227-a699-4f02-b552-cfa50691cc33"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "5px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><a style=\"text-decoration: none;\" href=\"https://www.example.com\" target=\"_blank\" rel=\"noopener\">Delivery and Returns</a></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "51c6df85-0870-4964-aee5-22a9ac9ba485"
                                },
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnMobile": false
                                        },
                                        "style": {
                                            "padding-bottom": "5px",
                                            "padding-left": "30px",
                                            "padding-right": "30px",
                                            "padding-top": "5px"
                                        },
                                        "text": {
                                            "computedStyle": {
                                                "linkColor": "#323e49"
                                            },
                                            "html": "<div class=\"txtTinyMce-wrapper\" style=\"line-height: 14px; font-size: 12px;\" data-mce-style=\"line-height: 14px; font-size: 12px;\"><p style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\" data-mce-style=\"font-size: 14px; line-height: 16px; word-break: break-word; text-align: left;\"><a style=\"text-decoration: none;\" href=\"https://www.example.com\" target=\"_blank\" rel=\"noopener\">Gift Cards</a></p></div>",
                                            "style": {
                                                "color": "#555555",
                                                "font-family": "inherit",
                                                "line-height": "120%"
                                            }
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-text",
                                    "uuid": "e0a1bdaa-2da8-4bb2-a2d2-2bccaedd35ee"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "7f3188df-3abf-4964-8b19-088c1915eaa5"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#efe6d7",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "four-columns-empty",
                    "uuid": "451f1152-8bc0-426e-a8f6-cb4acfbff74b"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "align": "center",
                                            "hideContentOnMobile": false
                                        },
                                        "divider": {
                                            "style": {
                                                "border-top": "0px solid transparent",
                                                "height": "80px",
                                                "width": "100%"
                                            }
                                        },
                                        "style": {
                                            "padding-bottom": "0px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "0px"
                                        }
                                    },
                                    "type": "mailup-bee-newsletter-modules-divider",
                                    "uuid": "92aa750f-ce5a-471d-ab52-3f1173a19e15"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "0px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "0px"
                            },
                            "uuid": "c8ee61d2-8a83-4eee-a269-0e72bf23907b"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "#efe6d7",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "rowColStackOnMobile": true,
                            "rowReverseColStackOnMobile": false
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "800px"
                        }
                    },
                    "type": "one-column-empty",
                    "uuid": "47a93b85-f38e-4703-a3fd-17fa6a690a3e"
                },
                {
                    "columns": [
                        {
                            "grid-columns": 12,
                            "modules": [
                                {
                                    "descriptor": {
                                        "computedStyle": {
                                            "hideContentOnDesktop": false,
                                            "hideContentOnMobile": false,
                                            "iconHeight": "32px",
                                            "iconSpacing": {
                                                "padding-bottom": "5px",
                                                "padding-left": "5px",
                                                "padding-right": "6px",
                                                "padding-top": "5px"
                                            },
                                            "itemSpacing": "0px",
                                            "itemsSpacing": "0px"
                                        },
                                        "iconsList": {
                                            "icons": [
                                                {
                                                    "alt": "Designed with BEE",
                                                    "height": "303px",
                                                    "href": "https://www.designedwithbee.com/",
                                                    "image": "https://d15k2d11r6t6rl.cloudfront.net/public/users/Integrators/BeeProAgency/53601_510656/Signature/bee.png",
                                                    "target": "_blank",
                                                    "text": "Designed with BEE",
                                                    "textPosition": "right",
                                                    "title": "Designed with BEE",
                                                    "width": "325px"
                                                }
                                            ]
                                        },
                                        "style": {
                                            "color": "#9d9d9d",
                                            "font-family": "inherit",
                                            "font-size": "15px",
                                            "padding-bottom": "5px",
                                            "padding-left": "0px",
                                            "padding-right": "0px",
                                            "padding-top": "5px",
                                            "text-align": "center"
                                        }
                                    },
                                    "locked": true,
                                    "type": "mailup-bee-newsletter-modules-icons",
                                    "uuid": "02aff5de-a889-4c69-8747-c33b24d151a6"
                                }
                            ],
                            "style": {
                                "background-color": "transparent",
                                "border-bottom": "0px solid transparent",
                                "border-left": "0px solid transparent",
                                "border-right": "0px solid transparent",
                                "border-top": "0px solid transparent",
                                "padding-bottom": "5px",
                                "padding-left": "0px",
                                "padding-right": "0px",
                                "padding-top": "5px"
                            },
                            "uuid": "e5c20607-c435-4d07-bfe0-48502ae12077"
                        }
                    ],
                    "container": {
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat"
                        }
                    },
                    "content": {
                        "computedStyle": {
                            "hideContentOnDesktop": false,
                            "hideContentOnMobile": false,
                            "rowColStackOnMobile": true
                        },
                        "style": {
                            "background-color": "transparent",
                            "background-image": "none",
                            "background-position": "top left",
                            "background-repeat": "no-repeat",
                            "color": "#000000",
                            "width": "500px"
                        }
                    },
                    "locked": true,
                    "type": "one-column-empty",
                    "uuid": "d406e8d1-8e9f-4328-b538-b9c98228f8a3"
                }
            ],
            "template": {
                "name": "template-base",
                "type": "basic",
                "version": "2.0.0"
            },
            "title": ""
        }
    }
}